import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CharacterSection from "./components/CharacterSection";
import CpSection from "./components/CpSection";
import TimelineSection from "./components/TimelineSection";
import RecommendSection from "./components/RecommendSection";
import GuideSection from "./components/GuideSection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CharacterSection />
        <CpSection />
        <TimelineSection />
        <RecommendSection />
        <GuideSection />
        <AboutSection />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}